<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="onConfirm"
  >
    <v-card-text class="mt-2">
      <v-row>
        <v-col>
          <v-text-field
            label="Orsak"
            outlined
            v-model="model.name"
            :rules="[required]"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal">Avbryt</v-btn>
      <v-btn rounded type="submit" color="primary" :loading="pending"
        >Uppdatera</v-btn
      >
    </v-card-actions>
  </v-form>
</template>

<script>
import { required } from '@/common/validationRules'
import gql from 'graphql-tag'

export default {
  name: 'MasterdataReasonsEditModal',

  props: {
    refetch: Function,
    item: Object
  },

  data: () => ({
    required,
    valid: true,
    pending: false,

    model: {
      name: ''
    }
  }),

  created() {
    this.model.name = this.item.name
  },

  methods: {
    async onConfirm() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return

      this.pending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: UpdateReasonInput!) {
            updateReason(payload: $payload) {
              reason_uuid
            }
          }
        `,
        variables: {
          payload: {
            uuid: this.item.uuid,
            patch: this.model
          }
        }
      })

      this.pending = false
      this.refetch()
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
